module.exports = __webpack_public_path__ + "static/media/ORISHA_BU_REAL_ESTATE_EXECUTE_NEGATIF_RVB.1bb3b459.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/ORISHA_BU_REAL_ESTATE_EXECUTE_NEGATIF_RVB.svg
// module id = 1039
// module chunks = 0